<template>
  <div class="one_step">
    <div class="step_shell for_pb">
      <div class="outcome_message" v-if="product==='dairy'">
        Unfortunately, it looks like you don’t meet our lending criteria, which means you’re not eligible for a Dairy Direct loan at the moment. 
        We have specific criteria for this loan, so this is not necessarily a reflection on your situation.
        <br/>Not sure why you’ve been declined? 
        <a :href="rules_link" target="_blank">Click here</a> to see our eligibility criteria.
      </div>
      <div class="outcome_message" v-else>
        Unfortunately, it looks like you don’t meet our lending criteria, which means you’re not eligible for a Sheep &amp; Beef Direct loan at the moment. 
        We have specific criteria for this loan, so this is not necessarily a reflection on your situation.
        <br/>Not sure why you’ve been declined? 
        <a :href="rules_link" target="_blank">Click here</a> to see our eligibility criteria.
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        product: '',  //#pjw
        rules_link: ''
      }
    },
    created: function() {            
      var app = this.$parent.$parent.application;
      this.product = app.product;       
      this.rules_link = this.product === 'dairy' ? process.env.DD_ELIGIBILITY_RULES_URL : process.env.ELIGIBILITY_RULES_URL;            
    }
  }
</script>
